import "../styles/Page.css";

function Settings() {
  return (
    <div className="page">
      <h2>⚙️ Settings Page</h2>
      <ul>
        <li>Profile Settings</li>
        <li>Security Settings</li>
        <li>Notification Settings</li>
      </ul>
    </div>
  );
}

export default Settings;
